<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">计算报价分</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <div class="table-section">
                <el-table :data="tableData" style="width: 100%" :show-header="true" border class="bid-score-table" >
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="sectionCode" label="标段编码" align="center" header-align="center"
                        min-width="120">
                    </el-table-column>
                    <el-table-column prop="sectionName" label="标段名称" align="center" header-align="center"
                        min-width="150">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="right" header-align="right" width="120">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleOperation(scope.row)">
                                计算报价得分
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </div>

        <!-- 投标单位选择弹窗 -->
        <el-dialog title="选择投标单位" :visible.sync="unitDialogVisible" width="70%" :close-on-click-modal="false" :append-to-body="true">
            <el-table ref="unitTable" :data="unitList" border @selection-change="handleSelectionChange" >
                <el-table-column type="selection" width="55" align="center">
                </el-table-column>
                <el-table-column type="index" label="NO." width="80" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="投标单位名称" align="center">
                </el-table-column>
                <el-table-column prop="basePrice" label="基准价" align="center">
                </el-table-column>
                <el-table-column prop="offerPrice" label="报价" align="center">
                </el-table-column>
                <el-table-column prop="score" label="得分" align="center">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="unitDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleCalculateScore">计算报价得分</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { getQuoteSectionList, getQuoteUnitList } from '@/api/agent/api'
export default {
    name: 'CalculateBidScore',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            tableData: [],
            unitDialogVisible: false,
            unitList: [],
            selectedUnits: [],
            currentSectionCode: ''
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getQuoteSectionList()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        async getQuoteSectionList() {
            const res = await getQuoteSectionList(this.projectCode)
            if (res.code === 200) {
                this.tableData = res.data
            } else {
                this.$message.error(res.msg || '操作失败')
            }

        },
        handleBack() {
            this.$router.go(-1)
        },
        // 返回项目流程界面
        handleReturn() {
            this.$router.go(-1)
        },

        // 操作按钮点击
        handleOperation(row) {
            this.currentSectionCode = row.sectionCode
            this.getQuoteUnitList(row.sectionCode)
        },
        async getQuoteUnitList(sectionCode) {
            const res = await getQuoteUnitList({
                sectionCode: sectionCode,
                isCalculate: 0
            })
            if (res.code === 200) {
                this.unitList = res.data
                this.unitDialogVisible = true
            } else {
                this.$message.error(res.msg || '操作失败')
            }
        },

        // 表格选择变化
        handleSelectionChange(selection) {
            this.selectedUnits = selection
        },

        // 计算报价得分
        async handleCalculateScore() {
            if (this.selectedUnits.length === 0) {
                this.$message.warning('请至少选择一个投标单位')
                return
            }

            const userIdList = this.selectedUnits.map(item => item.userId)

            const res = await getQuoteUnitList({
                sectionCode: this.currentSectionCode,
                isCalculate: 1,
                userIdList: userIdList
            })

            if (res.code === 200) {
                this.$message.success('计算报价得分成功')
                this.unitList = res.data
            } else {
                this.$message.error(res.msg || '计算失败')
            }
        },
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;
    }
}
</style>
